const subTopics = [
  { subject: 'History', name: 'Mesopotamia', key: 'ancient_mesopotamia' },
  { subject: 'History', name: 'Ancient Egypt', key: 'ancient_egypt' },
  { subject: 'History', name: 'Ancient China', key: 'ancient_china' },
  { subject: 'History', name: 'Indus Valley', key: 'ancient_indusvalley' },
  { subject: 'History', name: 'Mesoamerica', key: 'ancient_mesoamerica' },
  
  // Add more...
];

export default subTopics;

export const nameMap = {
  // Subjects
  history: "History",
  psychology: "Psychology",

  // Topics
  ancient_history: "Ancient History",
  medieval_era: "Medieval Era",

  // Subtopics
  ancient_egypt: "Ancient Egypt",
  ancient_mesopotamia: "Mesopotamia",
  ancient_china: "Ancient China",
  ancient_indusvalley: "Indus Valley",
  ancient_mesoamerica: "Mesoamerica"
};
